
import strings from '../../eyeguide-localization/strings.constants';
export const MSGDISPLAYTIME = 1;

const SPORTS = [
    
    strings.lsFootballTxt,
    strings.lsSoccerTxt,
    strings.lsHockeyTxt,
    strings.lsBaseballTxt,
    strings.lsBasketballTxt,
    strings.lsSoftballTxt,
    strings.lsTennisTxt,
    strings.lsVolleyballTxt,
    strings.lsMixedMartialArtsTxt,
    strings.lsBoxingTxt,
    strings.lsSkiingTxt,
    strings.lsSnowboardingTxt,
    strings.lsLacrosseTxt,
    strings.lsTrackandFieldTxt,
    strings.lsPoloTxt,
    strings.lsRugbyTxt,
    strings.lsCyclingTxt,
    strings.lsWalkingTxt,
    strings.lsDivingTxt,
    strings.lsWeightliftingTxt
];

const LEVELS = [
    strings.lsHighSchoolTxt,   
    strings.lsProfessionalTxt ,
    strings.lsUniversityTxt  ,
    strings.lsJuniorHighTxt  ,
    strings.lsYouthTxt   ,
    strings.lsOtherTxt,
    strings.lsAmateurTxt,
    strings.lsElementarySchoolTxt,
    strings.lsMiddleSchoolTxt,
    strings.lsLowerSchoolTxt,
    strings.lsUpperSchoolTxt,
];

const PROFILELISTSTYPES = {
    DEFAULT : 0,
    BASELINES_LAST_WEEK : 1,
    BASELINES_PENDING : 2,
    IMPAIRED_PROFILES : 3 
};

export const BASELINETYPE = {
    BASELINE: strings.lsBaselineTxt,
    TEST: strings.lsTestTxt
 };

export const GENDER = {
    0: strings.lsFemaleTxt,
    1: strings.lsMaleTxt,
    2: strings.lsOtherTxt,
    3: strings.lsUnspecifiedTxt
};

const NOTIFYFILTERTYPE = {
    0: strings.lsNoValueTxt,
    1: strings.lsHasValueTxt,
    2: strings.lsEitherTxt
};

const CONCUSSIONFILTERVALUE = {
    0: strings.lsYesTxt,
    1: strings.lsNoTxt,
    2: strings.lsBothTxt
};

const TESTTYPE = [
    strings.lsSeverlyImpairedTxt,
    strings.lsModeratelyImpairedTxt,
    strings.lsMildlyImpairedTxt,
    strings.lsBorderlineTxt,
    strings.lsLowAverageTxt,
    strings.lsAverageTxt,
    strings.lsHighAverageTxt,
    strings.lsSuperiorTxt,
    strings.lsVerySuperiorTxt
];

const ERROR_TEXT = {
    ERROR_WRONG_PWD: 'Wrong Password Entered',
    ERROR_USERNAME_REQ: 'Enter Username',
    ERROR_NOT_FOUND: 'NOT FOUND',
    ERROR_AUTH: 'jwt expired',
    ERROR_ACTIVE: 'no active',
    ERROR_INVALID_TEST: 'invalid tests',
    ERROR_OTP_EXPIRED: 'OTP EXPIRED',
    ERROR_UNAUTHORISED: 'UNAUTHORIZED USER',
    ERROR_UNAUTHORISED_TXT: 'Unauthorized!!!'
};

const DBTESTTYPE = {
    'Extremely Poor': 0,
    'Very Poor': 1,
    'Poor': 2,
    'Borderline': 3,
    'Low Average': 4,
    'Average': 5,
    'High Average': 6,
    'Superior': 7,
    'Very Superior': 8
};

export const LOGGEDINUSERTYPE = {
    'ExternalUser': 1,
    'InternaleUser': 0
};

export const GENERATEOTP_TYPE = {
    'sendOTP': 0,
    'resendOTP': 1
};

export const ACTIVE_BIT = {
    ACTIVE: 1,
    INACTIVE: 0,
    ALL : 2 
};

export const TESTFILENAME = strings.lsTestFileName;

export const VIEWSTATE = {
    HOME: strings.lsViewStateHomeTxt,
    ROSTER: strings.lsViewStateRosterTxt,
    USER: strings.lsViewStateUserTxt,
    TEST: strings.lsViewStateTestTxt,
    NOTIFICATION: strings.lsViewStateNotificationTxt,
    ORGANIZATION: strings.lsViewStateOrgTxt,
    LOGOUT: strings.lsViewStateLogoutTxt,
    EXTERNALHOME: strings.lsViewStateExternalHomeTxt,
    DASHBOARD: '/' + strings.lsViewStateDashboardTxt,
    EMPLOYEE: '/' + strings.lsViewStateEmployeeTxt,
    AUDIT: '/' + strings.lsViewStateAuditTxt,
    CUSTOMER: '/' + strings.lsViewStateCustomerTxt
  };

export const PROFILE_KEYS = [
    'profileID',
    'middlename',
    'birthdate',   
    'gender',
    'sport',
    'level',     
    'email',
    'phone',
];

export const ZENDESKTOKENTYPE = {
    SSO: 0,
    WIDGET: 1
};

export default class Constants {
    
    static getSports() {
        return SPORTS;
    }

    static getLevels() {
        return LEVELS;
    }

    static getProfileListTypes() {
        return PROFILELISTSTYPES;
    }

    static getGender() {
        return GENDER;
    }

    static getNotifyFilterType() {
        return NOTIFYFILTERTYPE;
    }

    static getConcussionFilterValue() {
        return CONCUSSIONFILTERVALUE;
    }

    static getTestTypes() {
        return TESTTYPE;
    }

    static getIndexForDBTestType(type: string) {
//        console.log('type', DBTESTTYPE[type]);
        return DBTESTTYPE[type];
    }

    static getActivitBit() {
        return ACTIVE_BIT;
    }

    static getErrorText() {
        return ERROR_TEXT;
    }

    static getZendeskTokenTypes() {
        return ZENDESKTOKENTYPE;
    }

}



// WEBPACK FOOTER //
// ./src/components/common/constants.tsx